console.log('top');



// use a script tag or an external JS file
document.addEventListener("DOMContentLoaded", (event) => {
    gsap.registerPlugin(ScrollTrigger)
    // gsap code here!
    if (window.matchMedia('(min-width: 769px)').matches) {
        const height = window.innerHeight;
        const sections = ['development', 'property', 'access', 'plan'];

        sections.forEach((sec, i) => {
            const offsetTop = height * 1.5 * (i + 1);

            gsap.set(`.${sec}`, {
                autoAlpha: 1,
                top: `${offsetTop}px`
            });


            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: `.${sec}`,
                    start: 'top top',
                    end: `+=${height * 1.5}`,
                    scrub: 1,
                    pin: true
                }
            });

            tl.to(`.${sec}`, {
                autoAlpha: 1,
                duration: 1
            });
        });

        gsap.to('.location', {
            scrollTrigger: {
                trigger: '.location',
                start: 'top top',
                end: `+=${height}`,
                scrub: 1,
            }
        });
        ScrollTrigger.create({
            trigger: '.location',
            start: 'top top',
            end: `+=${height * 2}`,
            scrub: 1,
            pin: true
        });

    }
});


const inTarget = document.querySelectorAll('.bgSide, .imgSide')
window.addEventListener('scroll', () => {
    for (let i = 0; i < inTarget.length; i++) {
        const rect = inTarget[i].getBoundingClientRect().top;
        const scroll = window.scrollY || document.documentElement.scrollTop;
        const offset = rect + scroll;
        const windowHeight = window.innerHeight; // 現在のブラウザの高さ
        if (scroll > offset - windowHeight + 500) {
            inTarget[i].classList.add('active');
        } else {
            inTarget[i].classList.remove('active');
        }
    }
});



// ______________________________________
// ______________________________________
// ______________________________________



// /* mv movie */

const mvBox = document.querySelectorAll('.movie_box');
const mv = document.querySelectorAll('.movie');
const skipBox = document.querySelectorAll('.btn_box');
const skip = document.querySelectorAll('.btn_item');
const imgItem = document.querySelectorAll('.imgItem');

mv.forEach((mv) => {
    mv.addEventListener('ended', function () {
        mvBox.forEach((mBox) => {
            mBox.classList.add('hide');
        });

        skipBox.forEach((sBox) => {
            sBox.classList.add('hide');
        })
    });
})

skip.forEach((skip) => {
    skip.addEventListener('click', function () {
        mvBox.forEach((mBox) => {
            mBox.classList.add('hide');
        });

        skipBox.forEach((sBox) => {
            sBox.classList.add('hide');
        })
    })
})

//____________________



function updateHeight() {
    const vh = window.innerHeight;
    const elements = document.querySelectorAll('.sec');

    elements.forEach((el) => {
        el.style.height = `${vh}px`; // ← この書き換えに transition が効く！
    })
}

window.addEventListener('resize', () => {
    requestAnimationFrame(updateHeight); // ← ブラウザの描画タイミングと合わせる
});

updateHeight();